import React from 'react';
import { Sparkles, Award, Heart, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Sparkles size={32} />,
      title: 'Luxury Experience',
      description: 'Indulge in world-class amenities and exceptional service'
    },
    {
      icon: <Award size={32} />,
      title: 'Award Winning',
      description: 'Recognized for excellence in hospitality and guest satisfaction'
    },
    {
      icon: <Heart size={32} />,
      title: 'Natural Beauty',
      description: 'Surrounded by scenic farmland and breathtaking landscapes'
    },
    {
      icon: <Users size={32} />,
      title: 'Personalized Service',
      description: 'Dedicated staff ensuring your every need is met'
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Discover Luxtansa</h2>
          <p className="section-subtitle">
            A sanctuary of sophistication nestled in nature's embrace
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p className="about-paragraph">
              Luxtansa Resorts is more than just a destination—it's an experience
              crafted for those who appreciate the finer things in life. Set against a
              backdrop of rolling farmland with Arecanut , Jackfruit, Mango trees and Paddy
              fields, our resort offers a perfect blend of luxury, comfort, and natural
              serenity.
            </p>
            <p className="about-paragraph">
              From our elegantly appointed rooms to our delicious-class dining and
              recreational facilities, every detail has been thoughtfully designed to
              provide you with an unforgettable escape. Whether you're seeking
              relaxation by our swimming pool, culinary adventures in our gourmet
              restaurant, or peaceful moments in our scenic farmland, Luxtansa promises
              a retreat like no other.
            </p>
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
